export interface IStepper {
  steps: IStepShow[];
}

export class Stepper implements IStepper {
  steps: StepShow[];

  constructor(steps: StepShow[]) {
    this.steps = steps;
  }
}

export interface IStepShow {
  isVisible: boolean;
  titles: ITitle[];
}

export class StepShow implements IStepShow {
  isVisible: boolean;
  titles: ITitle[];

  constructor(isVisible: boolean, titles: ITitle[]) {
    this.isVisible = isVisible;
    this.titles = titles;
  }
}

export interface ITitle {
  libelle: string;
  subtitles: ISubtitle[];
  isActive: boolean;
}

export class Title implements ITitle {
  libelle: string;
  subtitles: ISubtitle[];
  isActive: boolean;

  constructor(libelle: string, subtitles: ISubtitle[], isActive: boolean) {
    this.libelle = libelle;
    this.subtitles = subtitles;
    this.isActive = isActive;
  }
}

export interface ISubtitle {
  libelle: string;
  url: string[];
  isValid: boolean;
  isActive: boolean;
  isVisible: boolean;
}

export class Subtitle implements ISubtitle {
  libelle: string;
  url: string[];
  isValid: boolean;
  isActive: boolean;
  isVisible: boolean;

  constructor(
    libelle: string,
    url: string[],
    isValid: boolean,
    isActive: boolean,
    isVisible: boolean
  ) {
    this.libelle = libelle;
    this.url = url;
    this.isValid = isValid;
    this.isActive = isActive;
    this.isVisible = isVisible;
  }
}
